







import { defineComponent, computed } from '@nuxtjs/composition-api';
import NotificationBanner from '~/components/atoms/Notification/NotificationBanner.vue';

export default defineComponent({
  name: 'NotificationBannerCms',
  components: {
    NotificationBanner,
  },
  props: {
    message: {
      type: String,
      default: '',
    },
    hideBanner: {
      type: Boolean,
      default: false,
    },
  },
  setup (props: {
    message?: string,
    hideBanner?: boolean
  }) {
    const canShowBanner = computed(() => props.message && !props.hideBanner);
    return {
      canShowBanner,
    };
  },
});
